module.exports = __webpack_public_path__ + "static/media/user-img-depoimento-video-01.4658b0b9.jpg";